/**
 * @desc: 表情组件
 * */
import React from 'react';
import './emoj.scss';
import {
  EMOJ
} from '@/constants';
export default class Emoj extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <React.Fragment>
        <div
          className={this.props.selecting
            ? 'em-wrapper'
            : 'em-wrapper hide'}>
          {EMOJ.map((emoj, index) => {
            return (<li key={index} onClick={e => this.selectEmoj(emoj)}>{emoj}</li>);
          })}
        </div>
      </React.Fragment>
    );
  }
  // 选择一个表情
  selectEmoj(emoj) {
    this.props.$selectEmoj(emoj);
  }
}